// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// auth config import
import authConfig from "@src/auth/config.js";

// Axios Imports
import axios from "@src/service/axios";

// Loader Components
import showLoader from "@components/loader";

// secure ls
import { secureGet, secureSet, secureLs } from "@src/service/secureLs";

// toast
import { toast } from "react-toastify";

const initialUser = () => {
  // const item = window.localStorage.getItem(authConfig.storageUserDataKeyName);
  const item = secureGet(authConfig.storageUserDataKeyName);
  //** Parse stored json or if none return initialValue
  return item;
};

const getResolvedUserId = (userData) => {
  return userData?.id ?? userData?.userId ?? "";
};

const getAccessToken = () => {
  const item = window.localStorage.getItem(authConfig.storageTokenKeyName);
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

export const verifyToken = createAsyncThunk(
  "authentication/verifyToken",
  async () => {
    try {
      showLoader(true);
      const res = await axios.get("/token", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      showLoader(false);
      // return res.data;
      return Promise.resolve(res.data);
    } catch (err) {
      showLoader(false);
      toast.error("Session Expired!");
      // return false;
      return Promise.reject(err);
    }
  },
);

export const Logout = createAsyncThunk("authentication/logout", async () => {
  try {
    showLoader(true);
    const res = await axios.post("/logout", {
      headers: {
        "Content-Type": "application/json",
      },
    });
    showLoader(false);
    return res.data;
  } catch (err) {
    showLoader(false);
    toast.error("Session Expired!");
    return false;
  }
});

export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    userData: initialUser(),
    accessToken: getAccessToken(),
  },
  reducers: {
    changeUserData: (state, action) => {
      const newProfileImage = action.payload.profileImage;

      state.userData = {
        ...state.userData,
        profileImage: newProfileImage,
      };

      secureSet(authConfig.storageUserDataKeyName, {
        ...state.userData,
        profileImage: newProfileImage,
      });
    },
    changeOriginToken: (state, action) => {
      const originalAccessToken = window.localStorage.getItem(
        authConfig.storageTokenKeyName,
      );
      state[authConfig.storageMockAdminKeyName] = originalAccessToken;
      localStorage.setItem(
        authConfig.storageMockAdminKeyName,
        originalAccessToken,
      );
    },
    changeOriginReplaceToken: (state, action) => {
      const originalAccessToken = window.localStorage.getItem(
        authConfig.storageMockAdminKeyName,
      );
      state[authConfig.storageTokenKeyName] = originalAccessToken;
      localStorage.setItem(authConfig.storageTokenKeyName, originalAccessToken);
      localStorage.removeItem(authConfig.storageMockAdminKeyName);
    },
    changeAccessToken: (state, action) => {
      state[authConfig.storageTokenKeyName] = action.payload.accessToken;
      localStorage.setItem(
        authConfig.storageTokenKeyName,
        JSON.stringify(action.payload.accessToken),
      );
    },
    handleLogin: (state, action) => {
      state[authConfig.storageUserDataKeyName] = action.payload.userData;
      localStorage.setItem(
        "crmUserMobile",
        action.payload?.userData?.mobile ?? "",
      );
      localStorage.setItem(
        "crmUserId",
        String(getResolvedUserId(action.payload?.userData)),
      );
      // localStorage.setItem(authConfig.storageUserDataKeyName, JSON.stringify(action.payload.userData));
      secureSet(authConfig.storageUserDataKeyName, action.payload.userData);

      state[authConfig.storageTokenKeyName] = action.payload.accessToken;
      localStorage.setItem(
        authConfig.storageTokenKeyName,
        JSON.stringify(action.payload.accessToken),
      );

      secureSet("mobileRegex", action.payload.userData.mobileRegex);
      secureSet("dateFormat", action?.payload?.userData?.dateFormat);
      secureSet(
        "isLeadScoreUpdate",
        action?.payload?.userData?.isLeadScoreUpdate,
      );
      secureSet(
        "isSystemAdmin",
        Boolean(
          action?.payload?.userData?.isSystemAdmin ||
            action?.payload?.userData?.isCRMMainAdmin,
        ),
      );
    },
    handleLogout: (state) => {
      state.userData = {};
      state[authConfig.storageTokenKeyName] = null;
      state[authConfig.storageUserDataKeyName] = null;
      localStorage.removeItem("crmUserId");
      localStorage.removeItem("crmUserMobile");
      secureLs.remove("isSystemAdmin");
    },
  },

  extraReducers: (builder) => {
    builder.addCase(verifyToken.fulfilled, (state, action) => {
      if (action.payload) {
        state[authConfig.storageUserDataKeyName] = action.payload.userData;
        localStorage.setItem(
          "crmUserId",
          String(getResolvedUserId(action.payload?.userData)),
        );
        localStorage.setItem(
          "crmUserMobile",
          action.payload?.userData?.mobile ?? "",
        );
        // localStorage.setItem(authConfig.storageUserDataKeyName, JSON.stringify(action.payload.userData));
        secureSet(authConfig.storageUserDataKeyName, action.payload.userData);
        secureSet(
          "isSystemAdmin",
          Boolean(
            action.payload?.userData?.isSystemAdmin ||
              action.payload?.userData?.isCRMMainAdmin,
          ),
        );
      }
    });
  },
});

export const {
  handleLogin,
  handleLogout,
  changeAccessToken,
  changeUserData,
  changeOriginToken,
  changeOriginReplaceToken,
} = authSlice.actions;

export default authSlice.reducer;
